import { render, staticRenderFns } from "./propertyCompanyManageList.vue?vue&type=template&id=6d18d486&scoped=true"
import script from "./propertyCompanyManageList.vue?vue&type=script&lang=js"
export * from "./propertyCompanyManageList.vue?vue&type=script&lang=js"
import style0 from "./propertyCompanyManageList.vue?vue&type=style&index=0&id=6d18d486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d18d486",
  null
  
)

export default component.exports